<template>
    <vs-card>
        <div class="lessons_holder" v-if="addCoursework || courseWorkedit ? false : true">
            <div class="listing_holder">
                <vs-input label="Lesson Title" v-model="lessonPayload.name" placeholder="Enter Title" class="w-full mb-4" />
                <div class="mb-4">
                    <label class="vs-input--label">Lesson Description</label>
                    <vs-textarea v-model="lessonPayload.description" placeholder="Enter Description" class="w-full" />
                </div>
                <subject-component
                    :formType="checkingEdit"
                    :subjectDisabled="subjectDisabled"
                    v-model="subject_id"
                    :has_all_subject="has_all_subject"
                    validatorScope="Questions"
                    ref="childSubjectComponent"
                    @allSub="allSub"
                  ></subject-component>
            </div>
            <div class="detail_holder">
                <div class="grey_border px-6 py-4">
                <div class="each_topic_list">
                    <table
                    class="cstm_vuexy_table w-full"
                    v-if="lesson_topic.length > 0"
                    >
                        <tr  v-for="(lessonTopic, index) in lesson_topic" :key="index">
                            <td
                      style="width: 50px"
                      v-if="lessonTopic.topicFiles.length == 0"
                    >
                      <div class="icon_holder">
                        <span
                          v-if="lessonTopic.topic_type == 3"
                          class="material-icons-outlined"
                          >bookmarks</span
                        >
                        <span
                          v-if="lessonTopic.topic_type == 4"
                          class="material-icons-outlined"
                          >rule</span
                        >
                        <span
                          v-if="lessonTopic.topic_type == 6"
                          class="material-icons-outlined"
                          >title</span
                        >
                      </div>
                    </td>
                    <td
                      style="width: 50px"
                      v-if="lessonTopic.topicFiles.length > 0"
                    >
                      <div class="icon_holder">
                        <span
                          v-if="
                            lessonTopic.topicFiles[0].file.file_type.includes(
                              'video'
                            )
                          "
                          class="material-icons-outlined"
                          >play_arrow</span
                        >
                        <span
                          v-if="
                            lessonTopic.topicFiles[0].file.file_type.includes(
                              'audio'
                            )
                          "
                          class="material-icons-outlined"
                          >mic_none</span
                        >
                        <span
                          v-if="
                            lessonTopic.topicFiles[0].file.file_type.includes(
                              'application/pdf'
                            )
                          "
                          class="material-icons-outlined"
                          >folder_special</span
                        >
                      </div>
                    </td>
                    <td>{{ lessonTopic.name }}</td>
                    <td>{{ lessonTopic.description }}</td>
                    <td style="width: 20px">
                      <span
                        style="cursor: pointer"
                        class="material-icons-outlined"
                        @click="editTopic(index, lessonTopic)"
                        >edit</span
                      >
                    </td>
                    <td style="width: 20px">
                      <span
                        style="cursor: pointer"
                        class="material-icons-outlined"
                        @click="
                          deleteTopicFromLesson(lessonTopic.id)
                        "
                        >delete</span
                      >
                    </td>
                        </tr>
                    </table>
                </div>
                <div class="added_section">
                    <div class="flex w-full px-4 pt-4 pb-2">
                    <span class="material-icons">add_circle_outline</span>
                    <span class="pl-2">Add</span>
                    </div>
                    <ul class="icon_list">
                    <li @click="fetchTopicList('Video')">
                        <vs-tooltip text="Add Video" position="bottom">
                        <span class="material-icons-outlined">videocam</span>
                        </vs-tooltip>
                    </li>
                    <li  @click="fetchTopicList('Audio')">
                        <vs-tooltip text="Add Audio" position="bottom">
                        <span class="material-icons-outlined">mic_none</span>
                        </vs-tooltip>
                    </li>
                    <li  @click="fetchCourseworkExamList('Coursework')">
                        <vs-tooltip text="Add Coursework" position="bottom">
                        <span class="material-icons-outlined">bookmarks</span>
                        </vs-tooltip>
                    </li>
                    <li @click="fetchCourseworkExamList('Exam')">
                        <vs-tooltip text="Add Exam" position="bottom">
                        <span class="material-icons-outlined">rule</span>
                        </vs-tooltip>
                    </li>
                    <!-- <li @click="fetchTopicList('Report')">
                        <vs-tooltip text="Add Report" position="bottom">
                        <span class="material-icons-outlined">summarize</span>
                        </vs-tooltip>
                    </li> -->
                    <li  @click="fetchTopicList('Note')">
                        <vs-tooltip text="Add Note" position="bottom">
                        <span class="material-icons-outlined">description</span>
                        </vs-tooltip>
                    </li>
                    <li @click="fetchTopicList('File')">
                        <vs-tooltip text="Add File" position="bottom">
                        <span class="material-icons-outlined">folder_special</span>
                        </vs-tooltip>
                    </li>
                    <li>
                        <vs-tooltip text="Add Application" position="bottom">
                        <span class="material-icons-outlined">phone_iphone</span>
                        </vs-tooltip>
                    </li>
                    </ul>
                </div>
                <!-- <vs-button @click="CreateCourseContent"> Save</vs-button> -->
                </div>
            </div>
        </div>
        <vs-divider v-if="addCoursework || courseWorkedit ? false : true" />
        <div class="text-center" v-if="addCoursework || courseWorkedit ? false : true">
            <vs-button type="border" color="danger" class="mx-4 my-1" @click="$router.push('/pages/lessonlist') ">Cancel</vs-button>
            <vs-button class="mx-4 my-1" @click="creatingLesson">Save</vs-button>
        </div>

    <CourseExamModalComponent
      v-if="addCoursework"
      :fileType="fileType"
      :addCoursework="addCoursework"
      :topic_list="topic_list"
      @exportToCourse="exportToCourse"
      @closeModal="closeModalCoursework"
      @updatefetchTopic="updatefetchTopic"
      @loadMoreTopicCourse="loadMoreTopicCourse"
    />
    <FileModalComponent
      v-if="filemodalOpen"
      :filemodalOpen="filemodalOpen"
      :fileType="fileType"
      :topic_list="topic_list"
      @createTopic="createTopic"
      @exportToCourse="exportToCourseFile"
      @closePopupFileModal="closePopupFileModal"
      @loadMoreTopic="loadMoreTopic"
    />

    <EditFileModal
      v-if="fileModaledit"
      :fileType="fileType"
      :fileModaledit="fileModaledit"
      :content="content"
      @updateEachTopic="updateEachTopic"
      @exportToCourse="exportToCourseFile"
      @closeModalEditFile="closeModalEditFile"
    />
    <NoteComponent
      v-if="noteModal"
      :fileType="fileType"
      :noteModal="noteModal"
      :topic_list="topic_list"
      @createTopic="createTopic"
      @exportToCourse="exportToCourseFile"
      @closeModal="closeModal"
      @loadMoreTopic="loadMoreTopic"
    />

    <NoteCreationForCourse
      v-if="noteEditModal"
      fileType="Edit"
      :addNewNote="noteEditModal"
      :editPayload="content"
      @closeCreateModal="closeCreateModal"
      @updateEachTopic="updateEachTopic"
    />
    <vs-card
      style="background: #fff; position: relative"
      class="cstm_vx_card p-4"
      v-if="courseWorkedit"
      :class="{ show: courseWorkedit }"
    >
    
        <div slot="header"
          style="border-bottom: 1px solid rgba(0, 0, 0, 0.2)"
          class="flex flex-wrap justify-between items-center pb-5 mb-4">
          <h4>Edit {{ fileType }}</h4>
          <button @click.stop="closeEditModal" class="cc-close-modal">
            &times;
          </button>
        </div>
        <CourseOrExam
          :content="content"
          :type="fileType"
          :assignment_type="fileType == 'Coursework' ? 2 : 4"
          @closeEditModal="closeEditModal"
        />
    </vs-card>
    
    </vs-card>
</template>
<script>
import EditFileModal from '@/views/pages/v1/coursebuilder/components/editFiles.vue'
import CourseOrExam from '@/views/pages/v1/coursebuilder/components/AddCourseOrExam.vue'
import NoteCreationForCourse from '@/views/pages/v1/coursebuilder/components/NoteCreationForCourse.vue'

import SubjectComponent from '@/components/common/SubjectComponent'
import FileModalComponent from '@/views/pages/v1/coursebuilder/components/ContentFileComponet.vue'
import NoteComponent from '@/views/pages/v1/coursebuilder/components/NoteComponent.vue'
import CourseExamModalComponent from '@/views/pages/v1/coursebuilder/components/CourseExamModalComponent.vue'


import {
  getTopicList,
  createTopic,
  createLesson,
  newlessonfetch,
  updateTopic,
  updateCourseContent
  
} from '@/api/courseBuilder.js'

import { listAssignment } from '@/api/assignment-question'

export default {
  components: {
    FileModalComponent,
    NoteComponent,
    CourseExamModalComponent,
    SubjectComponent,
    CourseOrExam,
    NoteCreationForCourse,
    EditFileModal
  },
  mounted () {
    this.checkingEdit = this.$route.params.lesson_id ? 'Edit' : 'Save'
    if (this.$route.params.lesson_id) {
      this.lesson_id = this.$route.params.lesson_id
      this.fetchLessonDetails()
    }
  },
  data () {
    return {
      fileModaledit: false,
      noteEditModal: false,
      has_all_subject: false,
      subjectDisabled: false,
      subject_id:[],
      lesson_id:null,
      checkingEdit:'Save',
      addCoursework: false,
      customer_id: localStorage.getItem('customer_id'),
      content:null,
      lessonPayload:{
        name:null,
        description:null
      },
      courseWorkedit: false,
      fileType: null,
      topic_list:[],
      lesson_topic: [],
      topic_metadata: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      filemodalOpen:false,
      noteModal:false
      

    }
  }, 
  methods: {
    closeModalEditFile () {
      this.fileModaledit = false
    },
    closeCreateModal () {
      this.noteEditModal = false
    },
    allSub (data) {
      this.has_all_subject = data
    },
    async fetchLessonDetails () {
      const {data} = await newlessonfetch(this.customer_id, this.lesson_id)
      this.lessonPayload.name = data.data.lesson.name
      this.lessonPayload.description = data.data.lesson.description
      this.lesson_topic = data.data.lesson.topics
      this.has_all_subject = data.data.lesson.has_all_subject
      this.subject_id = data.data.lesson.subjects
    },
    closeEditModal (dataObj) {
      this.courseWorkedit = false
      dataObj.name = dataObj.title
      dataObj.id = this.content.id
      this.updateEachTopic(dataObj)
    },
    updateEachTopic (dataObj) {
      console.log(dataObj)
      const payload = {
        ...dataObj
      }
      if (dataObj.topic_type !== 6) {
        if (
          dataObj.assignment_type !== 'Exam' &&
          dataObj.assignment_type !== 'Homework'
        ) {
        // payload.files = dataObj.topicFiles[0].file_id
        } else if (dataObj.assignment_type === 'Exam') {
          payload.topic_type = 4
          payload.courseWork = dataObj.id
        } else if (dataObj.assignment_type === 'Homework') {
          payload.topic_type = 3
          payload.courseWork = dataObj.id
        }
      } else {
        payload.topic_type = 6
      }
      
      updateTopic(this.customer_id, dataObj.id, payload).then((data) => {
        if (payload.topic_type === 6) {
          this.noteEditModal = false
        } else {
          this.fileModaledit = false
        }
       
        this.lesson_topic = this.lesson_topic.map((ele, index) => {
          if (index === this.editIndex) {
            ele = data.data.data.topic
          } 
          return ele
        })
        this.updatefetchTopicFile(data.data.data.topic.topic_type)
      })
    },
    loadMoreTopicCourse (type) {
      try {
        const payload = {}
        if (type === 'Coursework') {
          payload.assignment_type_id = 2
        } else if (type === 'Exam') {
          payload.assignment_type_id = 4
        }

        listAssignment(
          payload,
          this.customer_id,
          this.topic_metadata.current_page + 1,
          {}
        ).then((data) => {
          this.topic_list.push(...data.data.data.assignmentlist)
          this.topic_metadata = data.data.data.meta
        })
      } catch (error) {
        console.log(error)
      }
    },
    async fetchCourseworkExamList (type) {
      const payload = {}
      this.fileType = type
      
      if (type === 'Coursework') {
        payload.assignment_type_id = 2
        this.addCoursework = true
        console.log(this.addCoursework)
      } else if (type === 'Exam') {
        payload.assignment_type_id = 4
        this.addCoursework = true
      }
      const { data } = await listAssignment(payload, this.customer_id, 1, {}, type === 'Coursework' ? 'courseWork_table' : 'exam_table', null)
      this.topic_list = data.data.assignmentlist
      this.topic_metadata = data.data.meta
    },
    async updatefetchTopic (fileType) {
      const payload = {}
      if (fileType === 'Coursework') {
        payload.assignment_type_id = 2
      } else if (fileType === 'Exam') {
        payload.assignment_type_id = 4
      }

      const { data } = await listAssignment(payload, this.customer_id, 1, {})
      this.topic_list = data.data.assignmentlist
      this.topic_metadata = data.data.meta
    },
    async creatingLesson () {
      try {
        if (this.checkingEdit !== 'Save') {
          this.$vs.loading({
            text:'Updating Lesson'
          })
        } else {
          this.$vs.loading({
            text:'Creating Lesson'
          })
        }
        
        const payload = {
          id:this.lesson_id,
          topics:this.lesson_topic,
          description: this.lessonPayload.description,
          name:this.lessonPayload.name,
          is_visible: true,
          subjects:this.subject_id,
          has_all_subject: this.has_all_subject

        }
       
        
        const resData = await createLesson(this.customer_id, payload)
        
       
        this.$vs.notify({
          title: 'Success',
          text: `Lesson ${this.checkingEdit}  Successfully`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })

        this.$router.push('/pages/lessonlist') 

      } catch (error) {
        //
      } finally {
        this.$vs.loading.close()
      }

    },
    exportToCourse (exportObj, obj2) {

      exportObj.topic_type = obj2
      this.createTopicForCoursework(exportObj)
      this.addCoursework = false
    },
    createTopicForCoursework (dataObj) {
      const payload = {
        ...dataObj,
        courseWork: dataObj.id,
        name: dataObj.title
      }
      createTopic(this.customer_id, payload).then((result) => {
        this.lesson_topic.push(result.data.data.topic)
      })
    },
    deleteTopicFromLesson (id) {
      this.lesson_topic = this.lesson_topic.filter((ele) => {
        if (ele.id !== id) return ele
      })
    },
    editTopic (index, content) {
      if (content.topic_type === 1) {
        this.fileType = 'Video'
      } else if (content.topic_type === 2) {
        this.fileType = 'Audio'
      } else if (content.topic_type === 5) {
        this.fileType = 'File'
      } else if (content.topic_type === 3) {
        this.fileType = 'Coursework'
      } else if (content.topic_type === 4) {
        this.fileType = 'Exam'
      } else if (content.topic_type === 6) {
        this.fileType = 'Note'
      }

      this.content = content

      this.editIndex = index
      if (content.topic_type === 3 || content.topic_type === 4) {
        this.courseWorkedit = true
      } else if (content.topic_type === 6) {
        this.noteEditModal = true
      } else {
        this.fileModaledit = true
      }
    },
    async updatefetchTopicFile (type) {
      const payload = {
        topic_type: type
      }
      const { data } = await getTopicList(this.customer_id, payload, 1)
      this.topic_list = data.data.topic
      this.topic_metadata = data.data.meta
    },
    createTopic (dataObj) {
      const payload = {
        ...dataObj
      }
      if (dataObj.topic_type === 6) {
        payload.note = dataObj.note
        payload.name = dataObj.title
      }
      createTopic(this.customer_id, payload).then((data) => {
        this.updatefetchTopicFile(data.data.data.topic.topic_type)
      })
    },
    async fetchTopicList (type) {
      try {
        this.fileType = type
        const payload = {}
        if (type === 'Video') {
          payload.topic_type = 1
        } else if (type === 'Audio') {
          payload.topic_type = 2
        } else if (type === 'File') {
          payload.topic_type = 5
        } else if (type === 'Note') {
          payload.topic_type = 6
        }
        getTopicList(this.customer_id, payload, 1).then((data) => {
          this.topic_list = data.data.data.topic
          this.topic_metadata = data.data.data.meta
          if (type === 'Video' || type === 'Audio' || type === 'File') {
            this.filemodalOpen = true
          } else if (type === 'Note') {
            this.noteModal = true
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    closeModal () {
      this.noteModal = false
    },
    closeModalCoursework () {
      this.addCoursework = false
    },
    closePopupFileModal () {
      this.filemodalOpen = false
    },
    exportToCourseFile (exportObj) {
      if (exportObj) {
        this.lesson_topic.push(exportObj)
        this.filemodalOpen = false
        this.noteModal = false
      }
    },
    loadMoreTopic (type) {
      try {
        if (this.topic_metadata.has_next) {
          const payload = {}
          if (type === 'Video') {
            payload.topic_type = 1
          } else if (type === 'Audio') {
            payload.topic_type = 2
          } else if (type === 'File') {
            payload.topic_type = 5
          } else if (type === 'Note') {
            payload.topic_type = 6
          }
          this.$vs.loading()
          getTopicList(
            this.customer_id,
            payload,
            this.topic_metadata.current_page + 1
          ).then((data) => {
            this.topic_list.push(...data.data.data.topic)
            this.topic_metadata = data.data.data.meta
            this.$vs.loading.close()
          })
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.$vs.loading.close()
      }
    }
  }
}
</script>